/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AbstractObject, uuid } from '@src/app/model/abstract-object';
import { Schedule } from '@src/app/model/schedule';

export class BCodeSchedule extends AbstractObject {
  bCodeId: uuid;
  scheduleId: uuid;
  schedule: Schedule;
  percent = 1.000; // : number;

  constructor(o: Partial<BCodeSchedule> = {}) {
    super(o);
  }
}
